<div class="loader">
  <div class="ball"></div>
  <div class="ball"></div>
  <div class="ball"></div>
</div>